import { render, staticRenderFns } from "./ResultsEmpty.vue?vue&type=template&id=56d93878&"
import script from "./ResultsEmpty.vue?vue&type=script&lang=js&"
export * from "./ResultsEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports